import { required, yup } from "./CommonValidation";
import * as Yup from 'yup';
export const XraySchema = (type) => { 
    // const numberRegExp = /^\d+$/
    const numberRegExp = /^\d+(\.\d{0,2})?$/
    const nameRegExp = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?0123456789]+/;

    if (type === 'xray') {
        return yup({
            xray_type_name: required("Please enter X-ray type name")
            .test('valid', 'X-ray Type Name must be in character.', (val= '')=> {
                if (nameRegExp.test(val)) {
                    return false;
                } else {
                    return true;
                }
            }),
            xray_charg_with_invest:required("Please enter X-ray Charges With Report")
            .test('valid', 'X-ray Charges With Report is not valid.', (val = '') => {
                const checkLength = val.replace(/\(|\)/g, '').length;
                if (checkLength === 0) {
                    return true;
                }
                if (numberRegExp.test(val)) {
                    return true;
                }
                return false;
            })
            .test('empty', 'X-ray Charges With Report is required.', (val = '') => {
                const checkLength = val.replace(/\(|\)/g, '').length;
                return checkLength > 0;
            }),
            xray_charg_without_invest:required("Please enter X-ray charges Without Report")
            .test('valid', 'X-ray charges Without Report is not valid.', (val = '') => {
                const checkLength = val.replace(/\(|\)/g, '').length;
                if (checkLength === 0) {
                    return true;
                }
                if (numberRegExp.test(val)) {
                    return true;
                }
                return false;
            })
            .test('empty', 'X-ray charges Without Report is required.', (val = '') => {
                const checkLength = val.replace(/\(|\)/g, '').length;
                return checkLength > 0;
            }),
          
        });
    } else if(type==='ADD_XRYMACHINE'){
        return yup({
            name: required("Please enter x-ray machine name"),
        });
    } 
};